var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0.5H3C1.34297 0.5 0 1.84297 0 3.5V15.5C0 17.157 1.34297 18.5 3 18.5H21C22.657 18.5 24 17.157 24 15.5V3.5C24 1.84297 22.6547 0.5 21 0.5ZM3 2H21C21.8269 2 22.5 2.67313 22.5 3.5V5.18797L13.35 12.0505C12.5531 12.6467 11.4455 12.6467 10.6486 12.0505L1.5 5.1875V3.5C1.5 2.675 2.17313 2 3 2ZM22.5 15.5C22.5 16.3269 21.8269 17 21 17H3C2.17313 17 1.5 16.3269 1.5 15.5V7.02031L9.75 13.25C10.4119 13.7473 11.2059 14.0009 12 14.0009C12.7941 14.0009 13.5891 13.7469 14.25 13.25L22.5 7.02031V15.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.cf680eb351d0c68c1ac7b50ee2a6399a.svg";
export { ForwardRef as ReactComponent };